export default (selectedAll, selectedRows) => ({
    total: 0,
    selectedAll,
    selectedRows,
    bulkCounting: 0,
    selectedCheckAll: false,
    lastSelectedRow: null,
    keysDown: new Set(),

    init() {
        this.$watch('total', () => this.countRows());
        this.$watch('selectedAll', () => this.countRows());
        this.$watch('selectedRows', () => this.countRows());

        this._keydownListener = (e) => {
            this.keysDown.add(e.key);
        };
        document.addEventListener('keydown', this._keydownListener);

        this._keyupListener = (e) => {
            this.keysDown.delete(e.key);
        };
        document.addEventListener('keyup', this._keyupListener);
    },

    destroy() {
        document.removeEventListener('keydown', this._keydownListener);
        document.removeEventListener('keyup', this._keyupListener);
    },

    countRows() {
        this.selectedCheckAll = this.selectedAll
            ? !this.selectedRows?.length
            : this.selectedRows?.length >= this.total && this.total > 0;

        this.bulkCounting = this.selectedAll
            ? this.total - this.selectedRows?.length
            : this.selectedRows?.length;
    },

    toggleSelectedRow(rowId) {
        const index = this.selectedRows.indexOf(rowId);
        const selected = index === -1;

        if (selected) {
            this.selectedRows.push(rowId);
        } else {
            this.selectedRows.splice(index, 1);
        }

        this.handleShiftSelection(rowId, selected);

        this.lastSelectedRow = { rowId, selected };
    },

    handleShiftSelection(rowId, selected) {
        if (!this.keysDown.has('Shift') || !this.lastSelectedRow) {
            return;
        }

        const lastEl = document.querySelector(`[id^="select-row-${this.lastSelectedRow.rowId}-"]`);
        const currentEl = document.querySelector(`[id^="select-row-${rowId}-"]`);

        if (!lastEl || !currentEl) {
            return;
        }

        const rows = Array.from(document.querySelectorAll('[id^="select-row-"]'));

        const start = rows.indexOf(lastEl);
        const end = rows.indexOf(currentEl);

        if (start === -1 || end === -1) {
            return;
        }

        const from = Math.min(start, end);
        const to = Math.max(start, end);

        for (let i = from; i <= to; i++) {
            const rowIdValue = this.getRowIdFromElement(rows[i]);
            const idx = this.selectedRows.indexOf(rowIdValue);

            if (selected && idx === -1) {
                this.selectedRows.push(rowIdValue);
            }

            if (!selected && idx !== -1) {
                this.selectedRows.splice(idx, 1);
            }
        }
    },

    toggleSelectedAll() {
        this.selectedAll = !this.selectedCheckAll;
        this.selectedCheckAll = this.selectedAll;
        this.selectedRows = [];
        this.lastSelectedRow = null;

        this.countRows();
    },

    isSelected(rowId) {
        return this.selectedAll
            ? !this.selectedRows?.includes(rowId)
            : this.selectedRows?.includes(rowId);
    },

    isNumeric(value) {
        return /^\d+$/.test(value);
    },

    getRowIdFromElement(el) {
        const idPart = el.id.split('-')[2];
        return this.isNumeric(idPart) ? Number(idPart) : idPart;
    },
});
